import { LegalDocumentPage } from "./LegalDocumentPage";

export const TermsPage = () => <LegalDocumentPage document="TERMS" />;
export const PrivacyPage = () => <LegalDocumentPage document="PRIVACY" />;
